const FULL_PAGE_CONFIG_EVENT = 'full-page-config-loaded' // fired from load_services.js.erb
const DEFAULT_POLL_INTERVAL = 500
const DEFAULT_TIMEOUT = 10000

function appendIfReady() {
  if (typeof window === 'undefined') {
    return false
  }

  if (typeof window.appendMTCaptcha === 'function') {
    window.appendMTCaptcha()

    return true
  }

  return false
}

function ensureMTCaptcha(options = {}) {
  const pollInterval = options.pollInterval || DEFAULT_POLL_INTERVAL
  const timeout = options.timeout || DEFAULT_TIMEOUT

  if (appendIfReady()) {
    return () => {}
  }

  let intervalId
  let timeoutId

  const handleConfigLoaded = () => {
    if (appendIfReady()) {
      cleanup()
    }
  }

  function cleanup() {
    if (typeof window === 'undefined') {
      return
    }

    window.removeEventListener(FULL_PAGE_CONFIG_EVENT, handleConfigLoaded)

    if (intervalId) {
      window.clearInterval(intervalId)
      intervalId = null
    }

    if (timeoutId) {
      window.clearTimeout(timeoutId)
      timeoutId = null
    }
  }

  if (typeof window !== 'undefined') {
    window.addEventListener(FULL_PAGE_CONFIG_EVENT, handleConfigLoaded)

    intervalId = window.setInterval(() => {
      if (appendIfReady()) {
        cleanup()
      }
    }, pollInterval)

    timeoutId = window.setTimeout(() => {
      cleanup()
    }, timeout)
  }

  return cleanup
}

export default ensureMTCaptcha

